var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetToWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9187 1.9917C17.4467 1.9917 21.9272 6.47218 21.9272 12.0002C21.9272 17.5283 17.4467 22.0087 11.9187 22.0087M8.49912 21.396C7.39151 20.9923 6.37286 20.4074 5.48766 19.6645M5.48766 4.33592C6.37286 3.59195 7.39151 3.00701 8.49912 2.60444M2.07031 10.2632C2.27604 9.09218 2.68306 7.99236 3.25688 6.99929M2.07031 13.7361C2.27604 14.9071 2.68306 16.007 3.25688 17",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6055 7.5365V12.7087L15.6711 15.1875",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetToWork);
export default __webpack_public_path__ + "static/media/get_to_work.44f4353c6125e5d1f1a98a0dd527c39e.svg";
export { ForwardRef as ReactComponent };